<template>
    <Modal :mask-closable="true" v-model="show" :title="title" :width="600" @on-cancel="clearFrom">
        <div class="QHcitySelect">
            <table class="QHtable">
                <tr v-if="provinceCode != -1 && !isDisabled.includes('provinceCode')">
                    <td width="80"><b>省份</b></td>
                    <td>
                        <Select placeholder="请选择省份" :label-in-value="true" v-model="provinceCode"
                            @on-change="(event) => select(event, 1)"
                            :disabled="$isblank(this.provinceList) || isReadonly.includes('provinceCode')">
                            <Option :value="item.code" :label="item.name" v-for="(item, index) in provinceList"
                                :key="index">{{ item.name }}</Option>
                        </Select>
                    </td>
                </tr>
                <tr v-if="cityCode != -1 && !isDisabled.includes('cityCode')">
                    <td width="80"><b>城市</b></td>
                    <td>
                        <Select placeholder="请选择城市" :label-in-value="true" v-model="cityCode"
                            @on-change="(event) => select(event, 2)"
                            :disabled="$isblank(this.cityList) || isReadonly.includes('cityCode')">
                            <Option :value="item.code" :label="item.name" v-for="(item, index) in cityList"
                                :key="index">{{
                                    item.name }}</Option>
                        </Select>
                    </td>
                </tr>
                <tr v-if="districtCode != -1 && !isDisabled.includes('districtCode')">
                    <td width="80"><b>区县</b></td>
                    <td>
                        <Select placeholder="请选择区县" :label-in-value="true" v-model="districtCode"
                            @on-change="(event) => select(event, 3)"
                            :disabled="$isblank(this.districtList) || isReadonly.includes('districtCode')">
                            <Option :value="item.code" :label="item.name" v-for="(item, index) in districtList"
                                :key="index">{{
                                    item.name }}</Option>
                        </Select>
                    </td>
                </tr>
                <tr v-if="streetCode != -1 && !isDisabled.includes('streetCode')">
                    <td width="80"><b>街道</b></td>
                    <td>
                        <Select placeholder="请选择街道" :label-in-value="true" v-model="streetCode"
                            @on-change="(event) => select(event, 4)"
                            :disabled="$isblank(this.streetList) || isReadonly.includes('streetCode')">
                            <Option :value="item.code" :label="item.name" v-for="(item, index) in streetList"
                                :key="index">{{
                                    item.name }}</Option>
                        </Select>
                    </td>
                </tr>
                <tr v-if="shequCode != -1 && !isDisabled.includes('shequCode')">
                    <td width="80"><b>社区</b></td>
                    <td>
                        <Select placeholder="请选择社区" :label-in-value="true" v-model="shequCode"
                            @on-change="(event) => select(event, 5)"
                            :disabled="$isblank(this.shequList) || isReadonly.includes('shequCode')">
                            <Option :value="item.code" :label="item.name" v-for="(item, index) in shequList"
                                :key="index">{{
                                    item.name }}</Option>
                        </Select>
                    </td>
                </tr>
                <tr v-if="address != -1 && !isDisabled.includes('address')">
                    <td width="80"><b>门牌</b></td>
                    <td>
                        <Input v-model="address" placeholder="请输入小区单元楼层门牌等"
                            :disabled="$isblank(this.shequCode) || isReadonly.includes('address')" />
                    </td>
                </tr>
                <tr v-if="coordinates != -1 && !isDisabled.includes('coordinates')">
                    <td width="80"><b>坐标</b></td>
                    <td>
                        <div class="flex-between">
                            <Input v-model="coordinates" placeholder="请输入地址坐标"
                                :disabled="$isblank(this.shequCode) || isReadonly.includes('coordinates')" />
                            <span @click="$QHopen.url('https://lbs.qq.com/getPoint/?ref=www.akgdh.com', 1300)">
                                <Tag class="rightTool" style="margin:0 !important;margin-left:5px !important;">拾取坐标
                                </Tag>
                            </span>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div slot="footer">
            <Button @click="clearFrom">取消</Button>
            <Button type="primary" @click="ok">确定</Button>
        </div>
    </Modal>
</template>

<script>
export default {
    data() {
        return {
            //基础配置
            title: "选择地址",
            show: false,
            isDisabled: [],
            isReadonly: [],
            //省市县镇村
            provinceList: [],
            cityList: [],
            districtList: [],
            streetList: [],
            shequList: [],
            //返参
            provinceCode: -1,
            cityCode: -1,
            districtCode: -1,
            streetCode: -1,
            shequCode: -1,
            address: -1,
            coordinates: -1,
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:methods
    // +----------------------------------------------------------------------
    methods: {
        //hiPop
        hiPop(addressAll, isDisabled, isReadonly) {
            this.clearFrom();
            this.isDisabled = isDisabled || [];
            this.isReadonly = isReadonly || [];
            this.show = true;
            if (addressAll.hasOwnProperty('provinceCode')) {
                this.provinceCode = addressAll.provinceCode || "";
                this.getOpenCityList(1);
            };
            if (addressAll.hasOwnProperty('cityCode')) {
                this.cityCode = addressAll.cityCode || "";
                this.getOpenCityList(2, this.provinceCode);
            };
            if (addressAll.hasOwnProperty('districtCode')) {
                this.districtCode = addressAll.districtCode || "";
                this.getOpenCityList(3, this.cityCode);
            };
            if (addressAll.hasOwnProperty('streetCode')) {
                this.streetCode = addressAll.streetCode || "";
                this.getOpenCityList(4, this.districtCode);
            };
            if (addressAll.hasOwnProperty('shequCode')) {
                this.shequCode = addressAll.shequCode || "";
                this.getOpenCityList(5, this.streetCode);
            };
            if (addressAll.hasOwnProperty('address')) {
                this.address = addressAll.address || "";
            };
            if (addressAll.hasOwnProperty('coordinates')) {
                this.coordinates = addressAll.coordinates || "";
            };
            this.show = true;
        },

        //城市信息列表
        async getOpenCityList(level, code) {
            let that = this;
            if (level != 1 && this.$isblank(code)) {
                return;
            };
            if (level == 1 && this.provinceCode == -1) {
                return;
            };
            if (level == 2 && this.cityCode == -1) {
                return;
            };
            if (level == 3 && this.districtCode == -1) {
                return;
            };
            if (level == 4 && this.streetCode == -1) {
                return;
            };
            if (level == 5 && this.shequCode == -1) {
                return;
            };
            this.$loading(true);
            var parameter = {
                level: level,
                code: code || ""
            };
            try {
                const res = await this.$api.getOpenCityList(parameter);
                if (res.code == 0) {
                    if (level == 1) {
                        that.provinceList = res.data;
                    } else if (level == 2) {
                        that.cityList = res.data;
                    } else if (level == 3) {
                        that.districtList = res.data;
                    } else if (level == 4) {
                        that.streetList = res.data;
                    } else if (level == 5) {
                        that.shequList = res.data;
                    };
                } else {
                    that.$msg(res.msg, "error");
                };
            } catch (error) {
                console.error('Error:', error);
            } finally {
                this.$loading(false);
            }
        },

        //取值
        ok() {
            var addressAll = {
                provinceCode: this.provinceCode,
                cityCode: this.cityCode,
                districtCode: this.districtCode,
                streetCode: this.streetCode,
                shequCode: this.shequCode,
                address: this.address,
                coordinates: this.coordinates
            };
            //组合value
            var filteredAddressAll = Object.keys(addressAll).reduce((acc, key) => {
                if (addressAll[key] !== -1) {
                    acc[key] = addressAll[key];
                };
                return acc;
            }, {});
            var addressAll = filteredAddressAll;

            //组合label
            var addressFull = "";
            var addressDetailed = "";
            if (addressAll.hasOwnProperty('provinceCode')) {
                var item = this.provinceList.find(item => item.code === addressAll.provinceCode);
                if (this.$isblank(item)) {
                    this.$msg("省份信息有误", "error");
                    return;
                };
                addressAll.province = item.name;
                addressFull = addressAll.province;
            };
            if (addressAll.hasOwnProperty('cityCode')) {
                var item = this.cityList.find(item => item.code === addressAll.cityCode);
                if (this.$isblank(item)) {
                    this.$msg("城市信息有误", "error");
                    return;
                };
                addressAll.city = item.name;
                if (addressAll.city != addressFull) {
                    addressFull = addressFull + addressAll.city;
                    addressDetailed = addressDetailed + addressAll.city;
                };
            };
            if (addressAll.hasOwnProperty('districtCode')) {
                var item = this.districtList.find(item => item.code === addressAll.districtCode);
                if (this.$isblank(item)) {
                    this.$msg("区县信息有误", "error");
                    return;
                };
                addressAll.district = item.name;
                addressFull = addressFull + addressAll.district;
                addressDetailed = addressDetailed + addressAll.district;
            };
            if (addressAll.hasOwnProperty('streetCode')) {
                var item = this.streetList.find(item => item.code === addressAll.streetCode);
                if (this.$isblank(item)) {
                    this.$msg("街道信息有误", "error");
                    return;
                };
                addressAll.street = item.name;
                addressFull = addressFull + addressAll.street;
                addressDetailed = addressDetailed + addressAll.street;
            };
            if (addressAll.hasOwnProperty('shequCode')) {
                var item = this.shequList.find(item => item.code === addressAll.shequCode);
                if (this.$isblank(item)) {
                    this.$msg("社区信息有误", "error");
                    return;
                };
                addressAll.shequ = item.name;
                addressFull = addressFull + addressAll.shequ;
            };
            if (addressAll.hasOwnProperty('address')) {
                if (!this.$isTitle (addressAll.address)) {
                    this.$msg("小区门牌信息有误", "error");
                    return;
                };
                addressFull = addressFull + addressAll.address;
                addressDetailed = addressDetailed + addressAll.address;
            };
            if (addressAll.hasOwnProperty('coordinates')) {
                if(!this.$isCoordinates(addressAll.coordinates )){
                    this.$msg("定位坐标信息有误", "error");
                    return;
                };
                addressFull = addressFull + "(" + addressAll.coordinates + ")";
            };
            addressAll.addressFull = addressFull;
            addressAll.addressDetailed = addressDetailed;
            this.$nextTick(() => {
                this.$emit('ok', addressAll);
                this.clearFrom();
            });
        },

        //选择地址
        select(event, level) {
            if (this.$isblank(event)) {
                var code = "";
            } else {
                var code = event.value;
            };

            //选择省份
            if (level == 1) {
                this.cityList = [];
                this.districtList = [];
                this.streetList = [];
                this.shequList = [];
                this.provinceCode = code;
                this.cityCode = this.disabled(this.cityCode, -1);
                this.districtCode = this.disabled(this.districtCode, -1);
                this.streetCode = this.disabled(this.streetCode, -1);
                this.shequCode = this.disabled(this.shequCode, -1);
                this.getOpenCityList(2, code);
            };

            //选择城市
            if (level == 2) {
                this.districtList = [];
                this.streetList = [];
                this.shequList = [];
                this.cityCode = code;
                this.districtCode = this.disabled(this.districtCode, -1);
                this.streetCode = this.disabled(this.streetCode, -1);
                this.shequCode = this.disabled(this.shequCode, -1);
                this.getOpenCityList(3, code);
            };

            //选择区县
            if (level == 3) {
                this.streetList = [];
                this.shequList = [];
                this.districtCode = code;
                this.streetCode = this.disabled(this.streetCode, -1);
                this.shequCode = this.disabled(this.shequCode, -1);
                this.getOpenCityList(4, code);
            };

            //选择街道
            if (level == 4) {
                this.shequList = [];
                this.streetCode = code;
                this.shequCode = this.disabled(this.shequCode, -1);
                this.getOpenCityList(5, code);
            };

            //选择社区
            if (level == 5) {
                this.shequCode = code;
            };
        },
        //如果不等于-1，则清空地址
        clearFrom() {
            this.title = "选择地址";
            this.show = false;
            this.isDisabled = [];
            this.provinceList = [];
            this.cityList = [];
            this.districtList = [];
            this.streetList = [];
            this.shequList = [];
            this.provinceCode = -1;
            this.cityCode = -1;
            this.districtCode = -1;
            this.streetCode = -1;
            this.shequCode = -1;
            this.address = -1;
            this.coordinates = -1;
        },

        //如果不等于-1，则清空地址
        disabled(str, newStr) {
            if (str == newStr) {
                return newStr;
            } else {
                return "";
            }
        },
    }
}
</script>
<style>